import store from "@/store";

const routes = [
  {
    path: "/accounting/debit-memo/:id",
    name: "acctdebit",
    component: () => import("@/views/main/modules/Accounting/DebitMemo/DebitMemoGroupComponent.vue"),
    beforeEnter: (to, from, next) => {
      store
        .dispatch("checkAccessUser", to.params.id)
        .then((response) => {
          if (response == "fail") {
            next("/no-access");
          } else {
            next();
          }
        })
        .catch(() => {});
    },
    meta: {
      requiresAuth: true,
      title: "Debit Memo",
    },
  },
];

export default routes;
